import React, {useEffect, useState} from "react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {Dialog, IconButton} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import CustomDialogTitle from "../custom-dialog-title";

const $ = window.jQuery;

const CustomDialog = ({
  open = false,
  title = null,
  titleProps = {},
  onClose = null,
  maxWidth = "lg",
  className = "",
  onEnter = null,
  onExit = null,
  disableFullscreen = false,
  children,
  ...props
}) => {
  const {t} = useTranslation();
  const messages = useSelector(state => state?.spinner?.messages ?? []);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (open) {
      setIsFullscreen(false);
    }
  }, [open]);

  return (
    <Dialog
      {...props}
      open={open}
      maxWidth={isFullscreen ? false : maxWidth}
      fullWidth
      onClose={onClose}
      className={`components__dialog components__dialog--custom ${className}`}
      disableEscapeKeyDown={messages.length > 0}
      slotProps={{
        paper: {
          sx: isFullscreen
            ? {
                margin: "32px !important",
                height: "calc(100% - 64px) !important",
                width: "calc(100% - 64px) !important"
              }
            : undefined
        },
        transition: {
          onEnter: () => {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.documentElement.style.setProperty("--scrollbar-width", `${scrollBarWidth}px`);

            document.body.classList.add("body--hidden-scrollbar");

            if (onEnter) onEnter();
          },
          onExit: () => {
            if ($(".components__dialog").length <= 1) {
              document.body.classList.remove("body--hidden-scrollbar");
            }

            if (onExit) onExit();
          }
        }
      }}
    >
      {title && (
        <CustomDialogTitle
          {...titleProps}
          onClose={onClose}
          className="components__dialog__header--custom"
          rightActions={
            disableFullscreen ? null : (
              <IconButton
                sx={{
                  padding: "4px"
                }}
                onClick={() => setIsFullscreen(!isFullscreen)}
                aria-label={t("components.customDialogTitle.fullscreen.ariaLabel")}
              >
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            )
          }
        >
          {title}
        </CustomDialogTitle>
      )}
      {children}
    </Dialog>
  );
};

export default CustomDialog;
